<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>设备管理</el-breadcrumb-item>
      <el-breadcrumb-item>反馈单</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <Rsljigou :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Orderid" label="订单号" width="220px"></el-table-column>
          <el-table-column prop="Jigouname" label="机构名称" width="120px"></el-table-column>
          <el-table-column prop="" label="反馈单图片" width="120px">
            <template v-slot="scope">
              <img :src="scope.row.Imageurl" min-width="48" height="64" />
            </template>
          </el-table-column>
          <el-table-column prop="" label="反馈单图片" width="120px">
            <template v-slot="scope">
              <el-link  size="mini" style="margin-left: 0; margin-right: 5px;color: #48c9b0;font-weight:bold;" :href="scope.row.Imageurl" target="_blank">点击查看</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="Cardnumbers" label="保修卡号字符串"></el-table-column>
          <el-table-column prop="Adminusername" label="操作员姓名" width="120px"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" width="180px"></el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 反馈单 start -->
      <el-tab-pane label="反馈单">
        <el-form :model="addForm" ref="addFormRef" label-width="75px">
          <el-form-item label="归属机构" class="addAdminForm">
            <Rsljigou :propsjigouid="addForm.jigouid" :propsjigouname="addForm.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item label="反馈单" class="addAdminForm">
            <TencentyunCosUploadImg :propsimageUrl="addForm.fileinfo" @change="changeTencentyunCosUploadImg" ></TencentyunCosUploadImg>
          </el-form-item>
          <el-form-item label="保修卡号" class="addAdminForm">
            <el-input v-model="addForm.cardnumber" placeholder="请输入保修卡号"></el-input>
            <el-button type="success" plain @click="apicheckcardnumber">录入</el-button>
            <el-checkbox-group v-model="addForm.checkedDevices">
                <el-checkbox v-for="device in addForm.devices" :label="device" :key="device">{{device}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickadd">添加</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 反馈单 end -->

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import TencentyunCosUploadImg from '@/components/TencentyunCosUploadImg.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou,
    TencentyunCosUploadImg
  },
  name: 'MyFanKuiDan',
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 查询客户
      keywords: {
        jigouid: '-1',
        jigouname: ''
      },
      // 添加设备
      addForm: {
        fileinfo: '',
        jigouid: '0',
        jigouname: '',
        checkedDevices: [],
        devices: []
      }
    }
  },
  mounted () {
    this.apiGetFanKuiDanNum()
    this.apiGetFanKuiDanList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    changeTencentyunCosUploadImg (url) {
      this.addForm.fileinfo = url
      this.$alert('上传成功', '提示')
    },
    changeRsljigou (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
      this.addForm.jigouid = vid
      this.addForm.jigouname = vname
    },
    clickreturn () {
      this.activeName = 'first'
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetFanKuiDanList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetFanKuiDanNum()
      this.apiGetFanKuiDanList()
    },
    clickadd () {
      this.apiAddFanKuiDan()
    },
    apiGetFanKuiDanList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetFanKuiDanList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetFanKuiDanNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetFanKuiDanNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddFanKuiDan: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.addForm.jigouid,
        imageurl: that.addForm.fileinfo,
        cardnumbers: that.addForm.checkedDevices.toString()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddFanKuiDan, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetFanKuiDanNum()
            that.apiGetFanKuiDanList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apicheckcardnumber: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        cardnumber: that.addForm.cardnumber
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_CheckCardnumber, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.addForm.checkedDevices.push(response.data.Cardnumber)
            that.addForm.devices.push(response.data.Cardnumber)
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
